import { initialRootState } from '../initialRootState';
import { ENavigationActionType, TNavigationActions } from './actions';

export interface INavigationState {
  screen: string | undefined;
  params: any;
}

export const navigationReducer = (
  currentState: INavigationState = initialRootState.navigation,
  action: TNavigationActions
): INavigationState => {
  switch (action.type) {
    case ENavigationActionType.UPDATE:
      return {
        ...currentState,
        ...action.payload,
      };
    default:
      return currentState;
  }
};
